<table mat-table [dataSource]="dataSource" matSort style="width: 100%;">

  <!-- login Column -->
  <ng-container matColumnDef="login">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.login' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.login }}</span>
    </td>
  </ng-container>

  <!-- firstName Column -->
  <ng-container matColumnDef="firstName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.firstName' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.firstName }}</span>
    </td>
  </ng-container>

  <!-- lastName Column -->
  <ng-container matColumnDef="lastName">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.lastName' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.lastName }}</span>
    </td>
  </ng-container>

  <!-- mail Column -->
  <ng-container matColumnDef="email">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.mail' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.email }}</span>
    </td>
  </ng-container>

  <!-- role Column -->
  <ng-container matColumnDef="role">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.role' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ ((element.roleName) ? ('label.role-'+ element.roleName + '-' + environmentName) : ('-') )| translate }}</span>
    </td>
  </ng-container>

  <!-- company Column -->
  <ng-container matColumnDef="company">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.company' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.company?.name }}</span>
    </td>
  </ng-container>

  <!-- creationDate Column -->
  <ng-container matColumnDef="creationDate">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header>{{ 'label.creation' | translate }}</div>
    </th>
    <td mat-cell *matCellDef="let element">
      <span> {{ element.creationDate | date : 'dd/MM/yy'}}</span>
    </td>
  </ng-container>

  <!-- action Column -->
  <ng-container matColumnDef="action">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header> </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="primary" (click)="onEditUser(element)" style="margin-right: 10px;">
        <mat-icon>edit</mat-icon>
        {{ 'button.edit' | translate }}
      </button>
      <button mat-raised-button color="warn" (click)="onDeleteUser(element)"
      *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
        <mat-icon>delete</mat-icon>
        {{ 'button.delete' | translate }}
      </button>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
    (click)="selectItemClick(row)"></tr>
</table>
<mat-paginator class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>